import { useId } from 'react';
import Media from './Media';

// The care team's note as the patient's card shows it: one component for the chat card and the dialog's preview.
export default function LabNoteBlock({ name, text }: { name?: string | null; text: string }) {
  const titleId = useId();
  const initial = name ? Array.from(name.trim())[0]?.toUpperCase() ?? '' : '';
  return (
    <section className="lab-note-block" aria-labelledby={titleId}>
      <div className="lab-note-block__head">
        {initial && <Media fallback={initial} size={28} className="lab-note-block__avatar" />}
        <div className="lab-note-block__who">
          <span id={titleId} className="body2 lab-note-block__title">Note from your care team</span>
          {name && <span className="detail1 lab-note-block__name">{name}</span>}
        </div>
      </div>
      <p className="body2 lab-note-block__text">{text}</p>
    </section>
  );
}
